import { FC, useRef } from "react";
import LABELS from "../../../../constants/labels/pump.labels";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import * as excelService from "../../../../services/calculations/calculation-output/excel.service";

interface PumpIterationProps {}

const PumpIteration: FC<PumpIterationProps> = () => {
  const tableRef = useRef<HTMLTableElement | null>(null);
  const { pumpIterationCollapse } = useAppSelector((state) => state?.collapse);

  const SelectedGKX = useAppSelector(
    (state) => state?.gasHandler?.gasHandlerPumpName
  );

  const SelectedChargePump1 = useAppSelector(
    (state) => state?.gasCalculations?.chargePumpName
  );
  const SelectedChargePump2 = useAppSelector(
    (state) => state?.gasCalculations?.chargePump2Name
  );
  const SelectedChargePump3 = useAppSelector(
    (state) => state?.gasCalculations?.chargePump3Name
  );
  const ChargePump1Iteration = useAppSelector(
    (state) => state?.pump.ChargePump1Iteration
  );
  const ChargePump2Iteration = useAppSelector(
    (state) => state?.pump.ChargePump2Iteration
  );
  const ChargePump3Iteration = useAppSelector(
    (state) => state?.pump.ChargePump3Iteration
  );
  const GKXPumpIteration = useAppSelector(
    (state) => state?.pump.GKXPumpIteration
  );
  const ProjectDetails = useAppSelector(
    (state) => state?.projectTab?.tab4Input?.projectName?.trim() || ""
  );
  const selectedPumpData = useAppSelector((state) => state?.pump.SelectedPump);

  const { updatePumpIterationCollapse } = useCollapseFacade();

  const handleCollapseChange = (key: boolean) => {
    updatePumpIterationCollapse(key);
  };

  const exportToExcel = () => {
    excelService.exportTableAsExcelFile(
      tableRef.current,
      "Pumps Iteration",
      "",
      ""
    );
  };

  const pumpIterlationList = useAppSelector(
    (state) => state.pump.PumpIteration
  );
  return (
    <>
      <Accordion
        title='Pumps iteration'
        isOpen={pumpIterationCollapse}
        onToggle={() => handleCollapseChange(!pumpIterationCollapse)}
        content={
          pumpIterlationList && (
            <div className='p-4'>
              <div className='flex float-right mb-4'>
                <button
                  onClick={exportToExcel}
                  className='ml-[16px] border-[1px] border-solid border-[#4A5463] py-[8px] px-[14px] inline-flex justify-center items-center gap-[8px] rounded-[8px] bg-transparent text-neutral-25'
                >
                  Export to excel
                </button>
              </div>
              <div
                className={`scrollable  relative overflow-auto  max-h-[400px] max-w-full inline-block w-[100%]`}
              >
                {GKXPumpIteration && (
                  <div className='card-body table-wrap'>
                    {ChargePump1Iteration && (
                      <div>
                        {ChargePump2Iteration && (
                          <div>
                            {ChargePump3Iteration && (
                              <table
                                ref={tableRef}
                                className='min-w-full rounded-[8px] outline-[1px] table'
                              >
                                <thead style={{ background: "#253040" }}>
                                  <tr>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div>{LABELS.stageNo}</div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.rs}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.bg}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.bo}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.volumegas}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.tfv}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.gvf}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.gor}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.glr}
                                      </div>
                                    </th>
                                    {/* <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                      <div className="flex items-center" style={{display: "none"}}>{LABELS.gvf}</div>
                    </th> */}
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.dischargePress}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.spGr}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.liftPerStage}
                                      </div>
                                    </th>
                                    <th className='px-[24px] py-[16px] text-[12px] text-neutral-25'>
                                      <div className='flex items-center'>
                                        {LABELS.bhpStages}
                                      </div>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {GKXPumpIteration.length > 0 && (
                                    <tr className='iterationSeparator'>
                                      <td
                                        colSpan={14}
                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4 w-full bg-darkcolor-400'
                                      >
                                        Gas handler: {SelectedGKX} |{" "}
                                        {GKXPumpIteration.length} stg
                                      </td>
                                    </tr>
                                  )}
                                  {GKXPumpIteration.map((item, index) => (
                                    <tr>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.stageNo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.rs}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bg}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.gasVolume}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepTFV}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepFreeGas}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepGOR}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpGLR}
                                      </td>
                                      {/* <td style={{display: "none"}} className="px-[24px] py-[9px] text-neutral-25 text-[14px] p-4">
                    {item.chargePumpTotalPressure}
                    </td> */}
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpTotalPressure}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.compositeSpGr}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.liftStage}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bhpStage}
                                      </td>
                                    </tr>
                                  ))}
                                  {ChargePump1Iteration?.length && (
                                    <tr>
                                      <td
                                        colSpan={14}
                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4 w-full bg-darkcolor-400'
                                      >
                                        Charge pump1:{SelectedChargePump1} |{" "}
                                        {ChargePump1Iteration?.length} stg
                                      </td>
                                    </tr>
                                  )}
                                  {ChargePump1Iteration.map((item, index) => (
                                    <tr>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.stageNo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.rs}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bg}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.gasVolume}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepTFV}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepFreeGas}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepGOR}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpGLR}
                                      </td>
                                      {/* <td style={{display: "none"}} className="px-[24px] py-[9px] text-neutral-25 text-[14px] p-4">
                    {item.chargePumpTotalPressure}
                    </td> */}
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpTotalPressure}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.compositeSpGr}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.liftStage}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bhpStage}
                                      </td>
                                    </tr>
                                  ))}
                                  {ChargePump2Iteration?.length && (
                                    <tr>
                                      <td
                                        colSpan={14}
                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4 w-full bg-darkcolor-400'
                                      >
                                        Charge pump2:{SelectedChargePump2} |{" "}
                                        {ChargePump2Iteration?.length} stg
                                      </td>
                                    </tr>
                                  )}
                                  {ChargePump2Iteration.map((item, index) => (
                                    <tr>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.stageNo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.rs}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bg}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.gasVolume}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepTFV}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepFreeGas}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepGOR}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpGLR}
                                      </td>
                                      {/* <td style={{display: "none"}} className="px-[24px] py-[9px] text-neutral-25 text-[14px] p-4">
                    {item.chargePumpTotalPressure}
                    </td> */}
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpTotalPressure}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.compositeSpGr}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.liftStage}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bhpStage}
                                      </td>
                                    </tr>
                                  ))}
                                  {ChargePump3Iteration?.length > 0 && (
                                    <tr>
                                      <td
                                        colSpan={14}
                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4 w-full bg-darkcolor-400'
                                      >
                                        Charge pump3:{SelectedChargePump3} |{" "}
                                        {ChargePump3Iteration?.length} stg
                                      </td>
                                    </tr>
                                  )}
                                  {ChargePump3Iteration.map((item, index) => (
                                    <tr>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.stageNo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.rs}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bg}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.gasVolume}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepTFV}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepFreeGas}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepGOR}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpGLR}
                                      </td>
                                      {/* <td style={{display: "none"}} className="px-[24px] py-[9px] text-neutral-25 text-[14px] p-4">
                    {item.chargePumpTotalPressure}
                    </td> */}
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpTotalPressure}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.compositeSpGr}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.liftStage}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bhpStage}
                                      </td>
                                    </tr>
                                  ))}
                                  {pumpIterlationList?.length > 0 && (
                                    <tr>
                                      <td
                                        colSpan={14}
                                        className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4 w-full bg-darkcolor-400'
                                      >
                                        Main Pump:{selectedPumpData?.pumpName} |{" "}
                                        {pumpIterlationList?.length} stg
                                      </td>
                                    </tr>
                                  )}
                                  {pumpIterlationList.map((item, index) => (
                                    <tr>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.stageNo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.rs}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bg}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bo}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.gasVolume}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepTFV}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepFreeGas}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpSepGOR}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpGLR}
                                      </td>
                                      {/* <td style={{display: "none"}} className="px-[24px] py-[9px] text-neutral-25 text-[14px] p-4">
                    {item.chargePumpTotalPressure}
                    </td> */}
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.chargePumpTotalPressure}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.compositeSpGr}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.liftStage}
                                      </td>
                                      <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] p-4'>
                                        {item.bhpStage}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )
        }
      />
    </>
  );
};

export default PumpIteration;
